export const RouterPaths = {
  home: '/',
  signup: '/signup',
  signupError: '/signup/error',
  authenticateHat: '/authenticate/hat',
  authenticateSignup: '/authenticate/signup',
  authenticateSuccess: '/authenticate/success',
  dashboard: '/dashboard',
  projects: '/projects',
  projectDetails: '/projects/details/:projectId',
  docs: '/docs',
  profile: '/profile',
  test: '/test',
  support: '/support',

  admin: '/admin',
  adminProjects: '/admin/projects',
  adminProject: '/admin/projects/:projectId',
  adminReview: '/admin/review-queue',
  adminDevelopers: '/admin/developers',

  manager: '/manager',
  managerProjects: '/manager/projects',
  managerProject: '/manager/projects/:projectId',
  managerReview: '/manager/review-queue',
};
